import { ImportCsvStatusResponse } from '@hooks/import/type';
import { TFunction } from 'i18next';

interface ProcessLiterals {
  quantityFailed: string | undefined;
  title: string;
}

const getFailedMessage = (
  statusData: ImportCsvStatusResponse | undefined,
  t: TFunction,
  key: string
): string | undefined => {
  return statusData?.failed?.quantity ? t(key) : undefined;
};

export const buildProcessLiterals = (
  statusData: ImportCsvStatusResponse | undefined,
  isLoading: boolean,
  t: TFunction
): Record<string, ProcessLiterals> => ({
  importCsv: {
    quantityFailed: getFailedMessage(statusData, t, 'common:processImportInfoWithErrors'),
    title: isLoading ? t('common:processImportCsvLoadingTitle') : t('common:processImportCsvSuccessTitle'),
  },
  invitation: {
    quantityFailed: getFailedMessage(statusData, t, 'common:processImportMultiInfoWithErrors'),
    title: isLoading
      ? t('common:processImportMultiInviteLoadingTitle')
      : t('common:processImportMultiInviteSuccessTitle'),
  },
  offlineSale: {
    quantityFailed: getFailedMessage(statusData, t, 'common:processImportMultiInfoWithErrors'),
    title: isLoading
      ? t('common:processMultiOfflineSalesLoadingTitle')
      : t('common:processMultiOfflineSalesSuccessTitle'),
  },
  passHolder: {
    quantityFailed: getFailedMessage(statusData, t, 'common:processImportPassHolderInfoWithErrors'),
    title: isLoading
      ? t('common:processImportPassHolderLoadingTitle')
      : t('common:processImportPassHolderSuccessTitle'),
  },
});
